import { fillText } from 'components/invoiceImport/invoiceImportText';

const numbers = new Intl.NumberFormat('fr-FR');

/** "1 240": thousands the French way. */
export const formatCount = (count) => numbers.format(count);

/** "22/09/2026 à 09:14", in the browser's time, as the error banner. */
export const formatRunStart = (text, startedAt) => {
  const started = new Date(startedAt);
  return fillText(text('history.startedAt', '{date} à {time}'), {
    date: started.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }),
    time: started.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    }),
  });
};

/** "12 s", "2 min 14 s", "1 h 05 min". */
export const formatDuration = (text, durationMs) => {
  const seconds = Math.round(durationMs / 1000);
  if (seconds < 60) {
    return fillText(text('history.seconds', '{s} s'), { s: seconds });
  }
  if (seconds < 3600) {
    return fillText(text('history.minutes', '{m} min {s} s'), {
      m: Math.floor(seconds / 60),
      s: seconds % 60,
    });
  }
  return fillText(text('history.hours', '{h} h {m} min'), {
    h: Math.floor(seconds / 3600),
    m: String(Math.floor((seconds % 3600) / 60)).padStart(2, '0'),
  });
};

/** One or many: "1 récupérée", "1 240 récupérées". */
export const countOf = (text, key, fallbacks, count) =>
  count === 1
    ? text(`history.${key}One`, fallbacks[0])
    : fillText(text(`history.${key}Many`, fallbacks[1]), {
        count: formatCount(count),
      });

// The sentence under a run that stopped as a whole.
const FATAL_SENTENCES = {
  ERR_BESTT_INDISPONIBLE: 'Bestt ne répondait pas : rien n’a été importé.',
  ERR_PASSAGE_INTERROMPU: 'Rien ne sera importé en double au prochain import.',
  generic: 'L’import a échoué.',
};

/**
 * The badge of a run (JBWEB-1281): its BadgeSquare type (colour), its label
 * and, for a run that stopped as a whole, the sentence that says why.
 */
export const runOutcome = (text, run) => {
  if (run.fatalCode === 'ERR_PASSAGE_INTERROMPU') {
    return {
      type: 24,
      label: text('history.interrupted', 'Interrompu'),
      sentence: text(
        'history.fatal.ERR_PASSAGE_INTERROMPU',
        FATAL_SENTENCES.ERR_PASSAGE_INTERROMPU,
      ),
    };
  }
  if (run.status === 'failed') {
    const known = run.fatalCode === 'ERR_BESTT_INDISPONIBLE';
    return {
      type: 25,
      label: text('history.failed', 'Échoué'),
      sentence: known
        ? text(
            'history.fatal.ERR_BESTT_INDISPONIBLE',
            FATAL_SENTENCES.ERR_BESTT_INDISPONIBLE,
          )
        : text('history.fatal.generic', FATAL_SENTENCES.generic),
    };
  }
  if (run.status === 'running') {
    return { type: 20, label: text('history.running', 'En cours') };
  }
  const failed = run.counters.bestt.failed + run.counters.pennylane.failed;
  if (failed > 0) {
    return {
      type: 3,
      label: fillText(text('history.inError', '{count} en erreur'), {
        count: formatCount(failed),
      }),
    };
  }
  return { type: 5, label: text('history.done', 'Terminé') };
};
